import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { InfoWindowComponent } from './info-window.component';

@NgModule({
  declarations: [
    InfoWindowComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    InfoWindowComponent
  ]
})
export class InfoWindowModule { }
